import {
  combineReducers,
  configureStore,
  type Reducer,
} from "@reduxjs/toolkit";
import userSelectionSlice from "./slices/userSelection/userSelection";
import userDetailSlice from "./slices/userDetail/userDetailSlice";
import brandsSlice from "./slices/brands/brandsSlice";
import marketsSlice from "./slices/markets/marketsSlice";
import filtersSlice from "./slices/filters/filtersSlice";
import segmentsSlice from "./slices/segments/segmentsSlice";
import CONFIG from "@/config";
// JS assistant reducer from geo-ui (ported as-is)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import chatReducer from "@/components/AIAssistant/state/chatReducer";
import featureStatusSlice from "./slices/featureStatus/featureStatusSlice";
import attributeLabelsSlice from "./slices/attributeLabels/attributeLabelsSlice";
import questionsSlice from "./slices/questions/questionsSlice";
import fileDownloadSlice from "./slices/fileDownload/fileDownloadSlice";
import ingestionSlice from "./slices/ingestionTime/ingestionTimesSlice";
import bootstrapDataStatusSlice from "./slices/bootstrapDataStatus/bootstrapDataStatusSlice";
import brandsOrderMappingSlice from "./slices/brandsOrderMapping/brandsOrderMappingSlice";
import screenLevelSelectionSlice from "./slices/screenLevelSelection/screenLevelSelection";
import screenConfigSlice from "./slices/screenConfig/screenConfigSlice";
import pendingSelectionSlice from "./slices/pendingSelection/pendingSelectionSlice";
import dataReadinessSlice from "./slices/dataReadiness/dataReadinessSlice";
import { selectionListenerMiddleware } from "./listeners/selectionListener";

const activeGroupReducer: Reducer<{
  brands: ReturnType<typeof brandsSlice>;
  markets: ReturnType<typeof marketsSlice>;
  filters: ReturnType<typeof filtersSlice>;
  segments: ReturnType<typeof segmentsSlice>;
  attributeLabels: ReturnType<typeof attributeLabelsSlice>;
  questions: ReturnType<typeof questionsSlice>;
  ingestionTime: ReturnType<typeof ingestionSlice>;
  bootstrapDataStatus: ReturnType<typeof bootstrapDataStatusSlice>;
  brandsOrderMapping: ReturnType<typeof brandsOrderMappingSlice>;
}> = combineReducers({
  brands: brandsSlice,
  markets: marketsSlice,
  filters: filtersSlice,
  segments: segmentsSlice,
  attributeLabels: attributeLabelsSlice,
  questions: questionsSlice,
  ingestionTime: ingestionSlice,
  bootstrapDataStatus: bootstrapDataStatusSlice,
  brandsOrderMapping: brandsOrderMappingSlice,
});

export const store = configureStore({
  reducer: {
    activeGroup: activeGroupReducer,
    featureStatus: featureStatusSlice,
    userSelection: userSelectionSlice,
    userDetail: userDetailSlice,
    fileDownload: fileDownloadSlice,
    screenLevelSelection: screenLevelSelectionSlice,
    screenConfig: screenConfigSlice,
    pendingSelection: pendingSelectionSlice,
    dataReadiness: dataReadinessSlice,
    // Assistant chat state (JS reducer)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    chat: chatReducer,
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(
      selectionListenerMiddleware.middleware as any,
    ) as any,
  devTools: String(CONFIG.env) !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
